<template>
    <div v-if="showNoDeviceSection == false">
        <KidHeader v-if="currentProfile" :style="{ 'max-width': '575px', 'margin': '0 auto', 'padding-left': '15px', 'padding-right': '15px' }" :profileId="currentProfile._id" :serialNumber="currentProfile.deviceDetail.serialNumber" />
        <div class="container">
            <div class="main-container">
                <div class="profile-section" v-if="currentProfile && currentProfile.deviceLimitReached == true">
                    <div class="alert alert-warning" role="alert">
                        <span class="text-danger"><b>All applications have been disabled</b></span> because the device limit has been reached.
                        Please increase the device limit to re-enable them now; otherwise, all applications will be automatically re-enabled when the day changes.
                    </div>
                </div>
                <div class="profile-section" v-if="useDefaultPassword == 'true'">
                    <div class="alert alert-warning" role="alert">
                        You are currently using the default password. <a href="javascript:void(0)" @click="$router.push({ path: '/change-password'})" >Click here</a> to update your password for enhanced security.
                    </div>
                </div>
                <div class="profile-section" v-if="currentProfile && currentProfile?.deviceDetail?.allowFullDeviceAccess == true">
                    <div class="alert alert-warning" role="alert">
                        Allow Full Access has been enabled. kid may be able to bypass security restrictions, potentially exposing the system to unauthorized actions or data access. <a href="javascript:void(0)" @click="$router.push({ path: '/global-settings', query: { profileId: this.currentProfile?._id, serialNumber: this.currentProfile?.deviceDetail?.serialNumber } })" >Click here</a> to change this setting.
                    </div>
                </div>
                <div class="profile-section mb-2" v-if="currentProfile && currentProfile.deviceDetail">
                    <div class="row">
                        <div class="col-1">
                            <img v-if="existingProfilePic" :src="existingProfilePic"  class="rounded-circle" alt="Profile Pic" width="50" height="50">
                            <DefaultProfilePicIcon v-else />
                        </div>
                        <div class="col-6 kids-name custom-pl">
                            <span class="pl-1" :style="{ 'font-size': '16px' }">
                                <a class="text-black" href="javascript:void(0)" @click="openKidsListModal()" v-if="currentProfile">
                                    {{ currentProfile.profile_name }} 
                                    <DownArrowIcon />    
                                </a>
                                <a class="text-black pr-2" href="javascript:void(0)" @click="openKidsprofilePageModal()" v-if="currentProfile">
                                    <i class="fas fa-pen pl-2"></i>
                                </a>
                                <!--<a class="text-black pl-2" href="javascript:void(0)" @click="$router.push({ path: '/device-info', query: { profile_id: this.currentProfile?._id, serialNumber: this.currentProfile?.deviceDetail?.serialNumber } })" v-if="currentProfile">
                                    <i class="fas fa-tablet-alt"></i>
                                </a>
                                <a class="text-black pl-2" href="javascript:void(0)" @click="$router.push({ path: '/global-settings', query: { profileId: this.currentProfile._id, serialNumber: this.currentProfile.deviceDetail.serialNumber, isPlaying: true } })" v-if="currentProfile">
                                    <i class="fas fa-volume-up"></i>
                                </a>-->
                            </span>
                            <p class="pl-1" v-if="currentProfile && currentProfile.deviceDetail">
                                <small class="device-name" v-if="!currentProfile.deviceDetail.appVersion">{{ currentProfile.deviceDetail.hardwareInfo.brand }} {{ currentProfile.deviceDetail.hardwareInfo.model }}</small>
                                <small class="device-name" v-else>Version: {{ currentProfile.deviceDetail.appVersion }}</small> 
                                <a href="javascript:void(0)" @click="openKidsAppStatusPopup()" v-if="currentProfile.deviceDetail.kidsApplicationStatus != 'Healthy'"><i class="fas fa-exclamation-triangle text-danger"></i></a>
                                <!--<a href="javascript:void(0)" @click="openKidsAppProtactionPopup()" class="pl-1">
                                    <i class="fas fa-unlock text-black" v-if="kidsAppProtectionStatus == false"
                                        :class="{
                                            'text-success': currentProfile.deviceDetail.appProtectionFcmDetail && currentProfile.deviceDetail.appProtectionFcmDetail.isDeviceAcknowledge === true,
                                            'text-warning': currentProfile.deviceDetail.appProtectionFcmDetail && currentProfile.deviceDetail.appProtectionFcmDetail.isDeviceAcknowledge !== true
                                        }"
                                    ></i>
                                    <i class="fas fa-lock text-black" v-else
                                        :class="{
                                            'text-success': currentProfile.deviceDetail.appProtectionFcmDetail && currentProfile.deviceDetail.appProtectionFcmDetail.isDeviceAcknowledge === true,
                                            'text-warning': currentProfile.deviceDetail.appProtectionFcmDetail && currentProfile.deviceDetail.appProtectionFcmDetail.isDeviceAcknowledge !== true
                                        }"
                                    ></i>
                                </a>-->
                            </p>  
                        </div>
                        <div class="col-5 custom-col-5 float-right">
                            <div class="float-right">
                                <span v-if="currentProfile && currentProfile.deviceDetail">
                                    <!--<a href="javascript:void(0)" class="text-black" @click="openSleepModeModal()"><i class="fas fa-info-circle fa-sm"></i></a>&nbsp;-->
                                    <a href="javascript:void(0)" @click="openSleepModeModal()">
                                        <i class="fas fa-bed text-black" :class="{
                                            'opacity-50': sleepMode === false,
                                            'text-success': currentProfile.deviceDetail.sleepModeFcmDetail && currentProfile.deviceDetail.sleepModeFcmDetail.isDeviceAcknowledge === true && currentProfile.sleepMode == true,
                                            'text-success-off-sleep-mode': currentProfile.deviceDetail.sleepModeFcmDetail && currentProfile.deviceDetail.sleepModeFcmDetail.isDeviceAcknowledge === true && currentProfile.sleepMode == false,
                                            'text-warning': currentProfile.deviceDetail.sleepModeFcmDetail && currentProfile.deviceDetail.sleepModeFcmDetail.isDeviceAcknowledge !== true
                                            }">
                                        </i>
                                    </a>&nbsp;
                                    <label class="switch" :style="{ 'height': '14px', width: '35px', 'line-height': 1}">
                                        <input type="checkbox" v-model="sleepMode" @click="toggleSleepMode()">
                                        <span class="sleep-mode slider round"></span>
                                    </label>

                                </span>&nbsp;
                                <span>
                                    <WifiIcon v-if="currentProfile && currentProfile.deviceDetail.wifiConnected == true"  />
                                    <NoWifiIcon v-else  />
                                </span>&nbsp;
                                <span v-if="currentProfile && currentProfile.deviceDetail && currentProfile.deviceDetail.batteryPercentage" :style="{ 'font-size': '14px' }">{{ currentProfile.deviceDetail.batteryPercentage }}% 
                                    <HalfBatteryIcon v-if="currentProfile.deviceDetail.batteryPercentage >= 20 && currentProfile.deviceDetail.batteryPercentage <= 80" />    
                                    <FullBatteryIcon v-else-if="currentProfile.deviceDetail.batteryPercentage > 80" />    
                                    <LowBatteryIcon v-else />    
                                </span>
                            </div>
                        </div>
                    </div>
                    
                    <div class="collapse footer" v-if="currentProfile" id="kidsAppProtectionPopup">
                        <div class="card">
                            <div class="card-body">
                                <h6 class="text-black">
                                    <b>Message</b> <a href="javascript:void(0)" class="text-black" @click="closeKidsAppProtactionPopup()"><i class="fas fa-times float-right pt-1 pr-2"></i></a>
                                </h6><hr>
                                <p class="text-black" v-if="kidsAppProtectionStatus == false"><b>Settings on Device:</b> Kids may be able to change device settings. To enhance security, please enable here the APP Setting Protection Status. 
                                    You might need to disable it, when the child needs to access settings like adding additional WLANs. </p>
                                <b>App Protection Status</b>&nbsp;
                                <label class="switch">
                                    <input type="checkbox" v-model="kidsAppProtectionStatus">
                                    <span class="slider round"></span>
                                </label>
                                <div class="profile-section text-center p-3">
                                    <button type="button" class="btn btn-primary" :style=" { 'background': '#0073EE', 'border-radius': '20px' }" @click="updateAppProtectionStatus()" :disabled="isDisabled">Save<span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span></button>&nbsp;
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <div class="collapse footer" v-if="currentProfile" id="kidsAppStatusPopup">
                        <div class="card">
                            <div class="card-body">
                                <h6 class="text-black">
                                    <b>Error Message</b> <a href="javascript:void(0)" class="text-black" @click="closeKidsAppStatusPopup()"><i class="fas fa-times float-right pt-1 pr-2"></i></a>
                                </h6><hr>
                                <p class="text-black">Following permissions are missing:</p>
                                <p class="text-black"><b>{{ currentProfile.deviceDetail.additionalData }}</b></p>
                                <p class="text-black">Please launch Wingio app on kids device  and grant the requested permissions.</p>
                            </div>
                        </div>
                    </div>
                
                    <div class="collapse footer" v-if="currentProfile" id="sleepModePopup">
                        <div class="card">
                            <div class="card-body">
                                <h6 class="text-black">
                                    <b>Sleep Mode</b> <a href="javascript:void(0)" class="text-black" @click="closeSleepMode()"><i class="fas fa-times float-right pt-1 pr-2"></i></a>
                                </h6><hr>
                                <p class="text-black">Enabling sleep mode will stop kids access to the device.</p>
                            </div>
                        </div>
                    </div>
                    <div class="collapse footer" id="navbarToggleExternalContent">
                        <div class="card">
                            <div class="card-body">
                                <p class="text-muted">
                                    <b>Choose Kids Profile</b>
                                    <span class="float-right"><a class="text-black" href="javascript:void(0)" @click="closeKidsScreen()"><i class="fas fa-times"></i></a></span>
                                </p>
                                <div class="ScrollStyle">
                                    <div class="profile-section mb-2" v-for="profile in profileList" :key="profile._id">
                                        <div class="row p-1" :class="{'opacity-25': profile.totalDevices == 0}">
                                            <div class="col-3 text-center">
                                                <img v-if="profile.deviceDetail && profile.deviceDetail.kidProfilePic" :src="profile.deviceDetail.kidProfilePic" class="rounded-circle" alt="Profile Pic" width="50" height="50">
                                                <DefaultProfilePicIcon v-else />
                                            </div>
                                            <div class="col kids-name">
                                                <span class="pl-1" :style="{ 'font-size': '14px' }" v-if="profile.totalDevices > 0">
                                                    <a class="text-black" href="javascript:void(0)" @click="switchProfile(profile)">
                                                        &nbsp;{{ profile.profile_name }} </a>
                                                </span>
                                                <span class="pl-2" v-else>
                                                    &nbsp;{{ profile.profile_name }}
                                                </span>
                                                <p v-if="profile.deviceDetail"><small class="pl-2">{{ profile.deviceDetail.serialNumber }}</small></p>
                                                <!--<p v-if="profile.deviceDetail">&nbsp;<small class="device-name">{{ profile.deviceDetail.hardwareInfo.brand }} {{ profile.deviceDetail.hardwareInfo.model }}</small></p>-->
                                            </div>
                                            <div class="col float-right">
                                                <div class="float-right">
                                                    <span :style="{ 'font-size': '12px' }">
                                                        <WifiIcon v-if="profile.totalDevices > 0 && profile.deviceDetail.wifiConnected == true" />
                                                        <NoWifiIcon v-else  />
                                                    </span>&nbsp;
                                                    <span v-if="profile.deviceDetail && profile.deviceDetail.batteryPercentage" :style="{ 'font-size': '12px' }">{{ profile.deviceDetail.batteryPercentage }}% 
                                                        <HalfBatteryIcon v-if="profile.deviceDetail.batteryPercentage >= 20 && profile.deviceDetail.batteryPercentage <= 80" />    
                                                        <FullBatteryIcon v-else-if="profile.deviceDetail.batteryPercentage > 80" />    
                                                        <LowBatteryIcon v-else />  
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Kids Profile Page -->
                    <div class="collapse footer modal-section" v-if="currentProfile" id="kidsProfilePage">
                    <div class="card">
                        <div class="card-body">
                        <h6 class="text-black">
                            <b>Update Kids Detail</b>
                            <a href="javascript:void(0)" class="text-black" @click="closeProfilePage()">
                            <i class="fas fa-times float-right pt-1 pr-2"></i>
                            </a>
                        </h6>
                        <hr>

                        <!-- Kids Update Form -->
                        <form @submit.prevent="submitKidDetails">
                            <!-- Kid's Name -->
                            <div class="form-group">
                                <label for="kidName">Kid's Name</label>
                                <input type="text" class="form-control" id="kidName" v-model="kidName" required>
                            </div>

                            <!-- Birth Month (display name, store number) -->
                            <div class="form-group">
                                <label for="birthMonth">Birth Month</label>
                                <select class="form-control" id="birthMonth" v-model.number="birthMonth" required>
                                    <option disabled value="">Select month</option>
                                    <option v-for="month in months" :key="month.value" :value="month.value">
                                    {{ month.name }}
                                    </option>
                                </select>
                            </div>

                            <!-- Birth Year -->
                            <div class="form-group">
                                <label for="birthYear">Birth Year</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="birthYear"
                                    v-model="birthYear"
                                    :min="2000"
                                    :max="new Date().getFullYear()"
                                    required
                                />
                            </div>


                            <!-- Profile Picture -->
                            <div class="form-group" v-if="!hideGoogleLogin">
                                <label>Profile Picture</label>
                                <div class="row">
                                    <!-- Existing Image -->
                                    <div class="col-6 mb-2 text-center" v-if="existingProfilePic">
                                        <small>Existing</small><br>
                                        <img :src="existingProfilePic" alt="Existing Profile" class="img-fluid rounded border" style="max-width: 100px;">
                                    </div>

                                    <!-- New Image Preview -->
                                    <div class="col-6 mb-2 text-center" v-if="newProfilePic">
                                        <small>New</small><br>
                                        <img :src="newProfilePic" alt="New Profile Preview" class="img-fluid rounded border" style="max-width: 100px;">
                                    </div>

                                    <!-- File Input -->
                                    <div class="col-12">
                                        <input type="file" @change="handleFileUpload" class="form-control-file mt-2">
                                    </div>
                                </div>
                            </div>
                            
                            <div class="profile-section text-center" >
                                <button type="submit" class="btn btn-primary" :style=" { 'background': '#0073EE', 'border-radius': '20px', 'width': '30%' }" @click="updateKidProfileDetail()" :disabled="isDisabled">
                                    Save<span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                                </button>
                            </div>
                        </form>
                        </div>
                    </div>
                    </div>
                </div>

                <div class="profile-section" v-if="this.currentProfile && this.currentProfile.deviceDetail && this.currentProfile.deviceDetail.lastDeviceLocation">
                    <div class="mt-2">
                        <h6>
                            <b>Last Location:</b> <a href="javascript:void(0)" @click="toggleMap()">{{ this.currentProfile.deviceDetail.lastDeviceLocation.latitude }}, {{ this.currentProfile.deviceDetail.lastDeviceLocation.longitude }} <DownArrowIcon /></a> 
                            <a class="pl-2" href="javascript:void(0)" @click="$router.push({ path: '/location-settings', query: { profileId: this.currentProfile._id, serialNumber: this.currentProfile.deviceDetail.serialNumber, isPlaying: true } })" v-if="currentProfile">
                                <i class="fas fa-compass"></i>
                            </a>
                        </h6>
                    </div>
                    <div v-if="showMap">
                        <small class="text-info" v-if="this.currentProfile && this.currentProfile.deviceDetail && this.currentProfile.deviceDetail.lastDeviceLocation"><b>Last Updated On: {{ formatDateTime(this.currentProfile.deviceDetail.lastDeviceLocation.deviceDateTime) }}</b></small>
                        <iframe v-if="iframeMapUrl" width="100%" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" :src="iframeMapUrl"></iframe>
                    </div>
                </div>

                <!--<div class="profile-section mb-2">
                    <div class="mt-2">
                        <h5><b>Live Location</b></h5>
                        <small class="text-info" v-if="this.currentProfile && this.currentProfile.deviceDetail && this.currentProfile.deviceDetail.lastDeviceLocation"><b>Last Updated On: {{ formatDateTime(this.currentProfile.deviceDetail.lastDeviceLocation.deviceDateTime) }}</b></small>
                        <iframe v-if="iframeMapUrl" width="100%" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" :src="iframeMapUrl"></iframe>
                        <div class="location-section" v-if="!iframeMapUrl">
                            <img src="https://cloud.kidfirstphone.com/new/images/google-map.png" class="img-responsive opacity-25" width="100%" alt="Cinque Terre"> 
                            <button class="btn img-button"><i class="fas fa-hourglass-start"></i> Coming Soon</button>
                        </div>
                    </div>
                </div>-->
                      
                <div class="collapse footer" id="ScreenTimeRecommendationPopup">
                    <div class="card">
                        <div class="card-body">
                            <h6 class="text-black">
                                <b>Screen Time Recommendation</b> <a href="javascript:void(0)" class="text-black" @click="closeScreenTimeRecommendation()"><i class="fas fa-times float-right pt-1 pr-2"></i></a>
                            </h6><hr>
                            <p class="text-black" v-html="kidScreenTimeRecommendation"></p>
                            <p class="text-black">Excemption of this screen time is to use the phone only for music and audiobooks - so for listening in the background and not active screen time. Screen time is only monitored while being active on the screen. Listening in the background is not getting tracked and is not included in the daily limits.</p>
                            <p class="text-black">More information: <a href="https://www.projuventute.ch/de/eltern/medien-internet/bildschirmzeit" target="_blank">Click Here</a></p>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="container" :style="{ 'background': '#f7f7f7', 'max-width': '575px' }">
            <div class="container-dark">
                    <div class="profile-section" :style="{ 'border': 'unset' }">
                        <h5 class="pb-2"><b>Activity</b></h5>
                        <div class="btn-group btn-group-justified nav nav-pills justify-content-center" role="tablist" >
                            <a class="btn btn-light nav-link w-50 active" :style="{ 'text-decoration': 'none', 'padding': '4px' }" href="javascript:void(0)" role="tab" data-toggle="tab" @click="changeFilterType('Day')">Day</a>
                            <a class="btn btn-light nav-link w-50" :style="{ 'text-decoration': 'none', 'padding': '4px' }" href="javascript:void(0)" role="tab" data-toggle="tab" @click="changeFilterType('Week')">Week</a>
                        </div>
                        <div class="pt-3">
                            <div class="input-group" :style="{ 'padding-right': '2px'}">
                                <div class="input-group-prepend">
                                    <div class="input-group-text" :style="{ 'background-color': 'white', 'border': 'unset' }" id="btnGroupAddon">
                                        <a class="text-black" href="javascript:void(0)" @click="previousDate()">
                                            <ArrowLeftIcon />  
                                        </a>
                                    </div>
                                </div>
                                <div class="form-control text-center text-black" :style="{ 'border': 'unset', 'font-weight': 'bold' }">{{ this.formattedDate }}</div>
                                <div class="input-group-prepend">
                                    <div class="input-group-text" :style="{ 'background-color': 'white', 'border': 'unset' }" id="btnGroupAddon">
                                        <a class="text-black" href="javascript:void(0)" @click="nextDate()">
                                            <ArrowRightIcon />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="profile-section" style="border-bottom: unset;">
                        <div class="card" :style="{ 'border': 'unset', 'max-width': 'unset' }">
                            <div class="card-body">
                                <h6 class="text-black">
                                    <b>Screen Time: </b><span class="text-primary"><b>{{ totalUsedTime }}</b> </span>
                                </h6> 
                                <small class="text-muted" v-if="kidScreenTimeRecommendation">
                                    <b>Daily active Screen Time Recommendation</b> 
                                    <a href="javascript:void(0)" @click="openScreenTimeRecommendation()" class="text-black">&nbsp;<i class="fas fa-info-circle fa-lg"></i></a>
                                    <br><br>
                                </small>
                                <CanvasJSChart v-if="mostUsedApplicationList.length > 0" :options="options" :styles="styleOptions"/>
                                <div v-else>
                                    <img v-if="filterType == 'Day'" :src="dayNoDataGraph" class="img-fluid" />
                                    <img v-else :src="weekNoDataGraph" class="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="profile-section" style="border-bottom: unset;">
                        <div class="card" :style="{ 'border': 'unset', 'max-width': 'unset'}">
                            <div class="card-body">
                                <h6 class="text-black"><b>Most Used Apps</b></h6>
                                
                                <div class="row border-bottom p-2" v-for="application in mostUsedApplicationList" :key="application._id">
                                    <div class="col-xs-2" v-if="application.playStoreDetail" :style="{ opacity: application.is_app_disabled ? 0.2 : 1 }">
                                        <img :src="application.playStoreDetail.icon" style="height: 40px; width: 40px;border-radius: 10px;">
                                    </div>&nbsp;
                                    <div class="col-xs-10" :style="{ 'width': '48%' }">
                                        <a href="javascript:void(0)" :style="{ 'font-size': '14px' }" @click="$router.push({ path: '/application', query: { package_name: application.packageName, profile_id: this.currentProfile._id, serialNumber: this.currentProfile.deviceDetail.serialNumber} })" class="text-black">
                                            <span v-if="application.playStoreDetail">
                                                {{ application.playStoreDetail.title }} 
                                                <label v-if="!application.dailyLimit"> - <b>{{ application.timeInMinuteFormatted }}</b></label>
                                            </span>
                                            <span v-else>{{ application.packageName }}
                                                <label v-if="!application.dailyLimit"> - <b>{{ application.timeInMinuteFormatted }}</b></label>
                                            </span>
                                            &nbsp;<span class="badge badge-danger" v-if="application.playStoreCategory == 'Others'">
                                                Not Managed
                                            </span>
                                        </a>
                                        <div>
                                            <div class="progress" v-if="application.dailyLimit">
                                                <div class="progress-bar" :class="{'bg-danger': application.timeInMinute >= application.dailyLimit }" role="progressbar" :style="{ width: application.progressBarPercentage + '%' }" aria-valuemax="100">
                                                    <span v-if="application.dailyLimit"><b>{{ application.timeInMinuteFormatted }}</b> / {{ application.dailyLimitFormatted }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xs-2" :style="{ 'width': '36%', 'text-align': 'right', 'padding-top': '5px' }">
                                        <a href="javascript:void(0)" :style="{ 'font-size': '14px' }" @click="$router.push({ path: '/application', query: { package_name: application.packageName, profile_id: this.currentProfile._id, serialNumber: this.currentProfile.deviceDetail.serialNumber} })" class="text-black">
                                            <ArrowLeftPlainIcon />
                                        </a>
                                    </div>
                                </div>
                                <div class="row p-2" v-if="totalMostUsedApps > 3">
                                    <div class="col-xs-3"></div>
                                    <div class="col-xs-5 pl-3" v-if="totalMostUsedApps > (this.currentMostUsedAppsPage * this.pageSize)">
                                        <a href="javascript:void(0)" @click="showMoreMostUsedApps()">
                                            <b>Show More</b>
                                        </a>
                                    </div>
                                    <div class="col-xs-5 pl-3" v-if="(this.currentMostUsedAppsPage * this.pageSize) > 3">
                                        <a href="javascript:void(0)" @click="showLessMostUsedApps()">
                                            <b>Show Less</b>
                                        </a>
                                    </div>
                                </div>
                                <p v-if="mostUsedApplicationList.length == 0">
                                    <NoDataIcon />
                                    No data to show
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="profile-section" style="border-bottom: unset;">
                        <div class="card" :style="{ 'border': 'unset', 'max-width': 'unset' }">
                            <div class="card-body">
                                <h6 class="text-black"><b>Most Used Categories</b></h6>
                                <div class="row border-bottom p-2" v-for="category in mostUsedCategory" :key="category._id" >
                                    <div class="col-xs-2" :style="{ opacity: category.isCategoryEnabled == false ? 0.2 : 1 }">
                                        <img src="https://cdn-icons-png.flaticon.com/512/2603/2603910.png" style="height: 40px; width: 40px;border-radius: 10px;">
                                    </div>&nbsp;
                                    <div class="col-xs-12" :style="{ 'width': '50%' }">
                                        <span>
                                            <a href="javascript:void(0)" @click="$router.push({ path: '/category', query: { id: category._id, profileId: this.currentProfile._id, serialNumber: this.currentProfile.deviceDetail.serialNumber }})" class="text-black">
                                                {{ category.category }} <small v-if="!category.progressBarPercentage"> - <b>{{ category.usedTimeFormat }}</b> / {{ category.dailyLimitTimeFormat }}</small>
                                            </a>
                                            <div v-if="category.progressBarPercentage">
                                                <div class="progress">
                                                    <div class="progress-bar" role="progressbar" :class="{'bg-danger': parseInt(category.usedTime) >= parseInt(category.dailyLimitTime) }"  :style="{ 'width': category.progressBarPercentage+'%'}" aria-valuemax="100">
                                                        <span><b>{{ category.usedTimeFormat }}</b> / {{ category.dailyLimitTimeFormat }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="col-xs-2" :style="{ 'width': '34%', 'text-align': 'right', 'padding-top': '5px' }">
                                        <a href="javascript:void(0)" @click="$router.push({ path: '/category', query: { id: category._id, profileId: this.currentProfile._id, serialNumber: this.currentProfile.deviceDetail.serialNumber }})" class="text-black">
                                            <ArrowLeftPlainIcon />
                                        </a>
                                    </div>
                                </div>
                                <div class="row p-2" v-if="totalMostUsedCategory > 3">
                                    <div class="col-xs-3"></div>
                                    <div class="col-xs-5 pl-3" v-if="totalMostUsedCategory > (this.currentCategoryPage * this.pageSize)">
                                        <a href="javascript:void(0)" @click="showMoreCategory()">
                                            <b>Show More</b>
                                        </a>
                                    </div>
                                    <div class="col-xs-5 pl-3" v-if="(this.currentCategoryPage * this.pageSize) > 3">
                                        <a href="javascript:void(0)" @click="showLessCategory()">
                                            <b>Show Less</b>
                                        </a>
                                    </div>
                                </div>
                                <p v-if="mostUsedCategory.length == 0">
                                    <NoDataIcon />
                                    No data to show
                                </p>
                                <!--<div class="row p-2">
                                    <div class="col-xs-2"></div>
                                    <div class="col-xs-10"><a href="">Show More</a></div>
                                </div>-->
                            </div>
                        </div>
                    </div>
                    
                    <div class="profile-section text-center pt-2">
                        Last Update: {{ lastUpdated }}
                    </div>
                <KidFooter v-if="currentProfile" :profileId="currentProfile._id" :serialNumber="currentProfile.deviceDetail.serialNumber" />
            </div>
        </div>
    </div>
    <div v-if="showNoDeviceSection == true">
        <div class="container">
            <div class="main-container">
                <div class="profile-section mb-2 sticky-top">
                    <div class="text-left">
                        <span>
                            <a href="javascript:void(0)" class="text-black">
                                <ThreeLineMenuIcon />

                            </a>&nbsp; 
                            <a href="javascript:void(0)" class="text-black" @click="$router.push({ path: '/kids-device'})">
                                <img :src="logo" height="19px" />
                            </a>
                        </span>
                        <div class="float-right">
                            <a href="javascript:void(0)" class="text-black">
                                <span class="unread-notification" v-if="unReadNotificationTotal > 0"></span>
                                <NotificationBellIcon /> 
                            </a>
                        </div>
                    </div>
                </div>
                <div class="profile-section" v-if="useDefaultPassword == 'true'">
                    <div class="alert alert-warning" role="alert">
                        You are currently using the default password. <a href="javascript:void(0)" @click="$router.push({ path: '/change-password'})" >Click here</a> to update your password for enhanced security.
                    </div>
                </div>
                <div class="profile-section mb-2">
                    <div class="text-left">
                        No devices have been added yet.
                    </div>
                    <!-- New Profile Button -->
                    <button type="button" class="btn btn-primary mb-2" :style="{ 'border-radius': '30px', width: '50%' }" @click="$router.push({ path: '/parent-profile' })">Go To Profile</button>

                    <!-- Go To Payment History Button -->
                    <button type="button" class="btn btn-success mb-2" :style="{ 'border-radius': '30px', width: '50%' }" @click="$router.push({ path: '/payment-history' })">Go To Payment History</button>

                    <!-- Log Out Button -->
                    <button type="button" class="btn btn-danger" :style="{ 'border-radius': '30px', width: '50%' }" @click="doLogout()">Log out</button>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import KidsService from "../../services/KidsService";
import ProfileService from "../../services/ProfileService";
import UserService from "../../services/UserService";

import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import DownArrowIcon from '@/components/icons/DownArrowIcon.vue'
import WifiIcon from '@/components/icons/WifiIcon.vue'
import NoWifiIcon from '@/components/icons/NoWifiIcon.vue'
import FullBatteryIcon from '@/components/icons/FullBatteryIcon.vue'
import HalfBatteryIcon from '@/components/icons/HalfBatteryIcon.vue'
import LowBatteryIcon from '@/components/icons/LowBatteryIcon.vue'
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue'
import ArrowRightIcon from '@/components/icons/ArrowRightIcon.vue'
import ArrowLeftPlainIcon from '@/components/icons/ArrowLeftPlainIcon.vue'
import NoDataIcon from '@/components/icons/NoDataIcon.vue'
import ThreeLineMenuIcon from '@/components/icons/ThreeLineMenuIcon.vue'
import NotificationBellIcon from '@/components/icons/NotificationBellIcon.vue'
import DefaultProfilePicIcon from '@/components/icons/DefaultProfilePicIcon.vue'

//let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

export default {
  name: 'Device Detail',
  components: {
    KidHeader,
    KidFooter,
    DownArrowIcon,
    NoWifiIcon,
    WifiIcon,
    FullBatteryIcon,
    HalfBatteryIcon,
    LowBatteryIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    ArrowLeftPlainIcon,
    NoDataIcon,
    ThreeLineMenuIcon,
    NotificationBellIcon,
    DefaultProfilePicIcon
  },
  props: {
    topLeftImage: {
        type: String,
        default: "./images/home-top-left.png",
    },
    appListIcon: {
        type: String,
        default: "./images/app-list-icon.png",
    },
    dayNoDataGraph: {
        type: String,
        default: "./images/day-nodata-graph.png",
    },
    weekNoDataGraph: {
        type: String,
        default: "./images/week-nodata-graph.png",
    },
    enrollmentQrCode: {
        type: String,
        default: "./images/kids-default-enrollment-qr-code.png",
    },
    logo: {
        type: String,
        default: "./images/lya-logo.png",
    },
    mediaVouchers: {
        type: String,
        default: "./images/mediengutscheine_diverses-printmedium_klicksafe.pdf",
    },
  },
  data() {
    return {
        profileId: this.$route.query.profileId,
        isDisabled: false,
        currentProfile: null,
        profileList: [],
        installedApplicationList: [],
        
        allMostUsedApplicationList: [],
        mostUsedApplicationList: [],
        totalMostUsedApps: 0,
        currentMostUsedAppsPage: 1,

        allMostUsedCategory: [],
        mostUsedCategory: [],
        totalMostUsedCategory: 0,
        currentCategoryPage: 1,
        pageSize: 3,
        defaultPageSize: 3,

        currentDate: new Date(),
        formattedDate: new Date().toLocaleDateString("en-US", this.$dateOptions),
        lastUpdated: "No data found.",
        options: null,
        styleOptions: {
          width: "100%",
          height: "250px"
        },
        iframeMapUrl: "",
        fullMapRedirectUrl: "",
        filterType: "Day",
        weekType: "Current",
        kidAge: null,
        kidScreenTimeRecommendation: "",
        totalUsedTime:"",
        sleepMode: false,
        showNoDeviceSection: false,
        useDefaultPassword: this.$route.query.useDefaultPassword,
        kidsAppProtectionStatus: false,

        kidName: null,
        birthMonth: null,
        birthYear: null,
        existingProfilePic: null,
        newProfilePic: null,
        kidProfileImagePayload: null,
        previewImage: null,
        months: [
            { name: 'January', value: 1 },
            { name: 'February', value: 2 },
            { name: 'March', value: 3 },
            { name: 'April', value: 4 },
            { name: 'May', value: 5 },
            { name: 'June', value: 6 },
            { name: 'July', value: 7 },
            { name: 'August', value: 8 },
            { name: 'September', value: 9 },
            { name: 'October', value: 10 },
            { name: 'November', value: 11 },
            { name: 'December', value: 12 }
        ],

        showMap: false,
        hideGoogleLogin: false
    }
  },
  computed: {
    
  },
  methods: {
    handleFileUpload(event) {
        const file = event.target.files[0];
        this.kidProfileImagePayload = file;
        if (file) {
            this.newProfilePic = URL.createObjectURL(file);
        }
    },
    toggleDataSeries(e) {
        if (typeof (e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
          e.dataSeries.visible = false;
        }
        else {
          e.dataSeries.visible = true;
        }
        e.chart.render();
    },
    calculateBoundingBox(latStr, longStr, zoomOutFactor) {
        const latitude = parseFloat(latStr);
        const longitude = parseFloat(longStr);

        // Check if the conversion was successful (NaN check)
        if (isNaN(latitude) || isNaN(longitude)) {
            console.error("Invalid latitude or longitude string");
            return null;
        }

        // Calculate the bounding box by subtracting/adding the zoomOutFactor to the center point coordinates
        const west = longitude - zoomOutFactor;
        const east = longitude + zoomOutFactor;
        const south = latitude - zoomOutFactor;
        const north = latitude + zoomOutFactor;
        
        // Return the bounding box as an object
        return {
            west: west,
            south: south,
            east: east,
            north: north
        };
    },
    async getKidsList() {
      let data = {
        profileId: (this.profileName) ? "" : this.profileId,
        search_profile_name: this.profileName,
        search_profile_type: "Android",
        pageSize: 50,
      }
      await KidsService.getKidsList(data)
        .then((response) => {
            this.profileList = response.data.data;
            if (this.profileList.length > 0 && this.profileList[0].deviceDetail) {

                this.showNoDeviceSection = false;
                if (this.profileId) {
                    const selectedProfile = this.profileList.find(item => item._id == this.profileId);
                    this.currentProfile = selectedProfile;
                } else {
                    this.currentProfile = this.profileList[0];
                    this.profileId = this.profileList[0]._id;
                }
                this.kidName = this.currentProfile.profile_name;
                if (this.currentProfile.deviceDetail) {
                    this.birthMonth = this.currentProfile.deviceDetail.birthMonth;
                    this.birthYear = this.currentProfile.deviceDetail.birthYear;
                    this.existingProfilePic = (this.currentProfile.deviceDetail.kidProfilePic) ? this.currentProfile.deviceDetail.kidProfilePic : null;
                    this.showMap = this.currentProfile.deviceDetail.enableLocationMapDisplay
                }

                this.kidsAppProtectionStatus = this.currentProfile.deviceDetail.protectionEnabled;
                //this.currentProfile = this.profileList[0];
                this.kidAge = this.currentProfile.deviceDetail.kidAge;
                this.sleepMode = this.currentProfile.sleepMode;
                if (this.kidAge >= 0 && this.kidAge < 2) {
                    this.kidScreenTimeRecommendation = "0 to 2 Years: In babies and toddlers, it is recommended to avoid screen media as much as possible."
                } else if (this.kidAge && this.kidAge >= 2 && this.kidAge < 4) {
                    this.kidScreenTimeRecommendation = "2 to 4 Years: For preschool children, the recommended time ranges from 5 to 10 minutes a day to a maximum of one hour of screen time. The latter should be the exception and not occur every day."
                } else if (this.kidAge && this.kidAge >= 4 && this.kidAge <= 8) {
                    this.kidScreenTimeRecommendation = "4 to 8 Years: Kindergarten children and primary school students should not sit in front of the screen for longer than 30 to a maximum of 60 minutes per day."
                } else if (this.kidAge && this.kidAge >= 9 && this.kidAge < 10) {
                    this.kidScreenTimeRecommendation = "9 to 10 Years: Kindergarten children and primary school students should not sit in front of the screen for longer than 30 to a maximum of 60 minutes per day."
                } else if (this.kidAge && this.kidAge >= 10) {
                    this.kidScreenTimeRecommendation = "From 10 years: With older children, a weekly time budget can be agreed upon. For example, one hour per year of age per week in the form of media vouchers.  Here you find a template: <a target='_blank' href='"+this.mediaVouchers+"'>Template</a>"
                } else {
                    this.kidScreenTimeRecommendation = ""
                }
                this.getDeviceProfileMostUsedApplicationList();
                this.getDeviceProfileApplicationList();
                this.getMostUsedCategory();
                this.getCategoryStackedChart();
                if (this.currentProfile.deviceDetail.lastDeviceLocation) {
                    let lat = parseFloat(this.currentProfile.deviceDetail.lastDeviceLocation.latitude);
                    let long = parseFloat(this.currentProfile.deviceDetail.lastDeviceLocation.longitude);

                    const centerLat = lat;   // Latitude of your center
                    const centerLong = long;  // Longitude of your center
                    const zoomOutFactor = 0.001;  // The factor to zoom out by (in degrees)

                    const boundingBox = this.calculateBoundingBox(centerLat, centerLong, zoomOutFactor);
                    const bbox = `${boundingBox.west},${boundingBox.south},${boundingBox.east},${boundingBox.north}`;
                    this.iframeMapUrl = `/map.html?lat=${lat}&long=${long}&zoom=12&bbox=${bbox}`;
                    //this.iframeMapUrl = "https://www.openstreetmap.org/export/embed.html?bbox=" + boundingBox.west + "," + boundingBox.south + "," + boundingBox.east + "," + boundingBox.north + "&zoom=12&layer=mapnik&marker=" + lat + "," + long;
                    this.fullMapRedirectUrl = "https://www.openstreetmap.org/?lat="+lat+"&lon="+long+"&zoom=13&layers=Q&mlat="+lat+"&mlon="+long;
                }
                if (this.currentProfile.deviceDetail.lastDeviceActivationDate) {
                    this.lastUpdated = new Date(this.currentProfile.deviceDetail.lastDeviceActivationDate).toLocaleDateString("en-US", this.$dateOptions) + " " + new Date(this.currentProfile.deviceDetail.lastDeviceActivationDate).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
                } else {
                    this.lastUpdated = "No data found.";
                }
            } else {
                this.$router.push({ path: '/parent-profile'})
                this.showNoDeviceSection = true;
            }
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
            if (e.response.data.is_logout == true) {
                this.$router.push({ path: '/login'})
            }
        });
    },
    openKidsListModal() {
        $('.collapse').collapse('hide');
        $('#navbarToggleExternalContent').collapse('show');
    },
    closeKidsScreen() {
        $('#navbarToggleExternalContent').collapse('hide');
    },
    getDeviceProfileApplicationList() {
      let data = {
        profile_id: this.currentProfile._id,
        install_type: "FORCE_INSTALLED",
        //serialNumber: this.currentProfile.deviceDetail.serialNumber,
      }
      ProfileService.getDeviceProfileApplicationList(data)
        .then((response) => {
          this.installedApplicationList = response.data.data;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async getDeviceProfileMostUsedApplicationList() {
      let data = {
        profileId: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType
      }
      await KidsService.getDeviceProfileMostUsedApplicationList(data)
        .then((response) => {
            let mostUsedApplicationList = response.data.data;
            this.allMostUsedApplicationList = mostUsedApplicationList;
            this.totalMostUsedApps = mostUsedApplicationList.length
            this.totalUsedTime = response.data.totalUsedTime
            this.mostUsedApplicationList = mostUsedApplicationList.slice(0, this.pageSize);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    showMoreMostUsedApps() {
        this.currentMostUsedAppsPage = this.currentMostUsedAppsPage + 1;
        let pageSize = this.pageSize * this.currentMostUsedAppsPage;
        this.mostUsedApplicationList = this.allMostUsedApplicationList.slice(0, pageSize);
    },
    showLessMostUsedApps() {
        this.mostUsedApplicationList = this.mostUsedApplicationList.slice(0, 3);
        this.currentMostUsedAppsPage = 1;
    },
    switchProfile(profile) {
        this.profileId = profile._id;
        this.$router.replace({
            path: this.$route.path, // Keeps the current path
            query: { 
                ...this.$route.query, // Retain existing query parameters
                profileId: profile._id 
            }
        });
        this.iframeMapUrl = "";
        this.fullMapRedirectUrl = "";
        this.currentProfile = profile;
        this.getDeviceProfileMostUsedApplicationList();
        this.getDeviceProfileApplicationList();
        this.getMostUsedCategory();
        this.getCategoryStackedChart();

        this.kidName = this.currentProfile.profile_name;
        if (this.currentProfile.deviceDetail) {
            this.birthMonth = this.currentProfile.deviceDetail.birthMonth;
            this.birthYear = this.currentProfile.deviceDetail.birthYear;
            this.existingProfilePic = this.currentProfile.deviceDetail.kidProfilePic;
            this.showMap = this.currentProfile.deviceDetail.enableLocationMapDisplay
        }
        this.kidAge = this.currentProfile.deviceDetail.kidAge;
        this.sleepMode = this.currentProfile.sleepMode;
        if (this.kidAge >= 0 && this.kidAge < 2) {
            this.kidScreenTimeRecommendation = "0 to 2 Years: In babies and toddlers, it is recommended to avoid screen media as much as possible."
        } else if (this.kidAge && this.kidAge >= 2 && this.kidAge < 4) {
            this.kidScreenTimeRecommendation = "2 to 4 Years: For preschool children, the recommended time ranges from 5 to 10 minutes a day to a maximum of one hour of screen time. The latter should be the exception and not occur every day."
        } else if (this.kidAge && this.kidAge >= 4 && this.kidAge <= 8) {
            this.kidScreenTimeRecommendation = "4 to 8 Years: Kindergarten children and primary school students should not sit in front of the screen for longer than 30 to a maximum of 60 minutes per day."
        } else if (this.kidAge && this.kidAge >= 9 && this.kidAge < 10) {
            this.kidScreenTimeRecommendation = "9 to 10 Years: Kindergarten children and primary school students should not sit in front of the screen for longer than 30 to a maximum of 60 minutes per day."
        } else if (this.kidAge && this.kidAge >= 10) {
            this.kidScreenTimeRecommendation = "From 10 years: With older children, a weekly time budget can be agreed upon. For example, one hour per year of age per week in the form of media vouchers.  Here you find a template: <a target='_blank' href='https://www.klicksafe.de/fileadmin/cms/download/Material/Div._Printmedium/Mediengutscheine_klicksafe_Deutsch_2021.pdf'>Template</a>"
        } else {
            this.kidScreenTimeRecommendation = ""
        }
        if (this.currentProfile.deviceDetail.lastDeviceLocation) {
            let lat = this.currentProfile.deviceDetail.lastDeviceLocation.latitude;
            let long = this.currentProfile.deviceDetail.lastDeviceLocation.longitude;

            const centerLat = lat;   // Latitude of your center
            const centerLong = long;  // Longitude of your center
            const zoomOutFactor = 0.001;  // The factor to zoom out by (in degrees)

            const boundingBox = this.calculateBoundingBox(centerLat, centerLong, zoomOutFactor);
            const bbox = `${boundingBox.west},${boundingBox.south},${boundingBox.east},${boundingBox.north}`;
            this.iframeMapUrl = `/map.html?lat=${lat}&long=${long}&zoom=12&bbox=${bbox}`;
            //this.iframeMapUrl = "https://www.openstreetmap.org/export/embed.html?bbox="+boundingBox.west+","+boundingBox.south+","+boundingBox.east+","+boundingBox.north+"&layer=mapquest&marker="+lat+","+long+"&zoom=12"
            this.fullMapRedirectUrl = "https://www.openstreetmap.org/?lat="+lat+"&lon="+long+"&zoom=13&layers=Q&mlat="+lat+"&mlon="+long;
        }
        if (this.currentProfile.deviceDetail.lastDeviceActivationDate) {
            this.lastUpdated = new Date(this.currentProfile.deviceDetail.lastDeviceActivationDate).toLocaleDateString("en-US", this.$dateOptions) + " " + new Date(this.currentProfile.deviceDetail.lastDeviceActivationDate).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
        } else {
            this.lastUpdated = "No data found.";
        }
        this.kidsAppProtectionStatus = this.currentProfile.deviceDetail.protectionEnabled;
        $('#navbarToggleExternalContent').collapse('hide');
    },
    async getMostUsedCategory() {
      let data = {
        profileId: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType
      }
      await KidsService.getMostUsedCategory(data)
        .then((response) => {
            let mostUsedCategory = response.data.data
            this.allMostUsedCategory = mostUsedCategory;
            this.totalMostUsedCategory = mostUsedCategory.length
            this.mostUsedCategory = mostUsedCategory.slice(0, this.pageSize);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    showMoreCategory() {
        this.currentCategoryPage = this.currentCategoryPage + 1;
        let pageSize = this.pageSize * this.currentCategoryPage;
        this.mostUsedCategory = this.allMostUsedCategory.slice(0, pageSize);
    },
    showLessCategory() {
        this.mostUsedCategory = this.allMostUsedCategory.slice(0, 3);
        this.currentCategoryPage = 1;
    },
    async getCategoryStackedChart() {
        let data = {
        profileId: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType
      }
      await KidsService.getCategoryStackedChart(data)
        .then((response) => {
            this.options = response.data.data
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async updateKidProfileDetail() {
        this.isDisabled =true;
        let formData = new FormData();
        formData.append("image", this.kidProfileImagePayload);
        formData.append("kidName", this.kidName); 
        formData.append("birthMonth", this.birthMonth)
        formData.append("birthYear", this.birthYear);
        formData.append("profileId", this.currentProfile._id);
        formData.append("serialNumber", this.currentProfile.deviceDetail.serialNumber);
        KidsService.updateKidProfileDetail(formData)
        .then((response) => {
            this.getKidsList();
            this.newProfilePic = null;
            this.kidProfileImagePayload = null;
            this.isDisabled =false;
            this.$toast.success(response.data.respones_msg);
            $('.collapse').collapse('hide');
        }).catch((e) => {
            this.isDisabled =false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    changeFilterType(type) {
        this.filterType = type;
        if (this.filterType == "Day") {
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions);
        } else {
            this.formattedDate = "This Week";
            this.weekType = "Current";
        }
    },
    previousDate() {
        if (this.filterType == "Day") {
            let day = this.currentDate.getTime() - (1 * 24 * 60 * 60 * 1000);
            this.currentDate.setTime(day);
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions);
        } else {
            this.formattedDate = "Previous Week"
            this.weekType = "Previous";
        }
        this.getCategoryStackedChart();
        this.getDeviceProfileMostUsedApplicationList();
        this.getMostUsedCategory();
    },
    nextDate() {
        if (this.filterType == "Day") {
            let day = this.currentDate.getTime() + (1 * 24 * 60 * 60 * 1000);
            this.currentDate.setTime(day);
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions)
        } else {
            this.formattedDate = "This Week",
            this.weekType = "Current";
        }
        
        this.getCategoryStackedChart();
        this.getDeviceProfileMostUsedApplicationList();
        this.getMostUsedCategory();
    },
    openScreenTimeRecommendation() {
        $('.collapse').collapse('hide');
        $('#ScreenTimeRecommendationPopup').collapse('show')
    }, 
    closeScreenTimeRecommendation(){
        $('#ScreenTimeRecommendationPopup').collapse('hide')
    },
    openSleepModeModal() {
        $('.collapse').collapse('hide');
        $('#sleepModePopup').collapse('show')
    },
    closeSleepMode(){
        $('#sleepModePopup').collapse('hide')
    },
    closeProfilePage() {
        $('#kidsProfilePage').collapse('hide')
    },
    openKidsprofilePageModal() {
        $('.collapse').collapse('hide');
        $('#kidsProfilePage').collapse('show')
    },
    openKidsAppStatusPopup() {
        $('.collapse').collapse('hide');
        $('#kidsAppProtectionPopup').collapse('hide')
        $('#kidsAppStatusPopup').collapse('show')
    },
    closeKidsAppStatusPopup(){
        $('#kidsAppStatusPopup').collapse('hide')
    },
    openKidsAppProtactionPopup() {
        $('.collapse').collapse('hide');
        $('#kidsAppStatusPopup').collapse('hide')
        $('#kidsAppProtectionPopup').collapse('show')
    },
    closeKidsAppProtactionPopup(){
        $('#kidsAppProtectionPopup').collapse('hide')
    },
    async toggleSleepMode() {
        let data = {
            profileId: this.currentProfile._id,
            sleepMode: (this.sleepMode == true) ? false : true,
            serialNumber: this.currentProfile.deviceDetail.serialNumber
        }
        await KidsService.toggleSleepMode(data)
        .then((response) => {
            this.$toast.success(response.data.respones_msg);  
            $('#sleepModePopup').collapse('hide')
            //this.sleepMode = (this.sleepMode == true) ? false : true
            this.applyPolicy();
            setTimeout(() => {
                this.getKidsList();
            }, 2000);

        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    applyPolicy() {
      this.isDisabled = true;
      let data = {
        profile_id: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber
      };

      ProfileService.applyPolicy(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
        })
        .catch((e) => {
          this.isDisabled = false;
          //this.$toast.error(e.response.data.respones_msg);
        });
    },
    doLogout() {
        UserService.logout()
        .then((response) => {
            localStorage.setItem('token', "");
            this.$toast.success(response.data.respones_msg);
            this.$router.push('login');
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async updateAppProtectionStatus() {
        let data = {
            profileId: this.currentProfile._id,
            kidsAppProtectionStatus: this.kidsAppProtectionStatus,
            serialNumber: this.currentProfile.deviceDetail.serialNumber
        }
        await KidsService.updateKidsProtectionStatus(data)
        .then((response) => {
            this.$toast.success(response.data.respones_msg);
            $('#kidsAppProtectionPopup').collapse('hide');
            setTimeout(() => {
                this.getKidsList();
            }, 3000);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    formatDateTime(datetime) {
      if (!datetime) return '';

      const date = new Date(datetime);

      const datePart = date.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });

      const timePart = date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });

      return `${datePart} ${timePart}`;
    },
    toggleMap() {
        this.showMap = (this.showMap == true) ? false : true;
        KidsService.updateDevice({ _id: this.currentProfile.deviceDetail._id, enableLocationMapDisplay: this.showMap  })
        .then((response) => {
        }).catch((e) => {
            this.isDisabled =false;
            this.$toast.error(e.response.data.respones_msg);
        });
    }
  },
  watch: {
    filterType() {
        this.getCategoryStackedChart();  
        this.getMostUsedCategory();  
        this.getDeviceProfileMostUsedApplicationList();
    },
  },
  beforeMount() {
    this.getKidsList();
    if (window.Android && typeof Android.sendData === "function") {
        Android.sendData(localStorage.getItem('token'));
    } else {
        console.log("Android interface is not available");
    }

    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosHandler) {
        window.webkit.messageHandlers.iosHandler.postMessage(localStorage.getItem('token'));
    } else {
        console.log("iOS interface is not available");
    }

  },
   created() {
    this.hideGoogleLogin = localStorage.getItem('hideGoogleLogin') === 'true';
  },
  mounted() {
    this.socket = io(process.env.VUE_APP_API_BASE_URL); // Replace with IP or domain if needed

    this.socket.on("connect", () => {
      console.log("Connected to Socket.IO server!", this.socket.id);
    });

    const statusData = {
      deviceId: 'abc123',
      status: 'online',
      timestamp: new Date().toISOString()
    };

    this.socket.emit("child_status", statusData);
    
    this.socket.on("child_status", (data) => {
        console.log("Child Status Event Received:", data);
        // You can update your UI or store with this data
    });
    
    // Optional: handle disconnect
    this.socket.on("disconnect", () => {
      console.log("Disconnected from Socket.IO server");
    });
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
}
</script>
<style scoped>
.alert {
    font-size: 12px;
    padding: .50rem 1rem;
}
</style>